import { Component, OnInit } from "@angular/core";
import { ProfileService } from "../../services/profile.service";
import { ProfileInfo } from "../../model/interface.model";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  profileImg: string | ArrayBuffer = "assets/images/profile.png";
  user: ProfileInfo = null;

  constructor(private profile: ProfileService) {}
  ngOnInit() {
    this.getProfileInfo();
  }

  getProfileInfo() {
    this.profile.userInfoBasic().subscribe(
      (response) => {
        this.user = response.data;
        // if (this.user.profileImg) {
        //   this.getProfileImage(this.user.profileImg);
        // }
      },
      (error) => {}
    );
  }

  getProfileImage(name: string) {
    this.profile.getProfileImage(name).subscribe((response) => {
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          this.profileImg = reader.result;
        },
        false
      );

      if (response) {
        reader.readAsDataURL(response);
      }
    });
  }
}
